(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.multicolumn-card.with-border[data-ti-image-shape="chamfer"]';
    const tracked = new WeakSet();
    const ns = 'http://www.w3.org/2000/svg';
    function draw(card) {
      const style = getComputedStyle(card);
      const w = card.offsetWidth, h = card.offsetHeight;
      if (!w || !h) return;
      const cut = Math.min(parseFloat(style.getPropertyValue('--ti-image-cut')) || 0, w / 2, h / 2);
      const softSetting = parseFloat(card.closest('[data-ti-multicolumn-softness]')?.dataset.tiMulticolumnSoftness) || 0;
      const soft = Math.min(softSetting, cut / 4);
      const i = .5, r = Math.max(0, Math.min(parseFloat(style.borderBottomLeftRadius) || 0, w / 2, h / 2) - i);
      const x = w - cut + i - Math.SQRT2, y = cut - i + Math.SQRT2;
      const t = soft * Math.SQRT1_2;
      let svg = card.querySelector(':scope > .ti-multicolumn-outline');
      if (!svg) {
        svg = document.createElementNS(ns, 'svg');
        svg.classList.add('ti-multicolumn-outline');
        svg.setAttribute('aria-hidden', 'true');
        svg.appendChild(document.createElementNS(ns, 'path'));
        card.appendChild(svg);
      }
      svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
      svg.firstElementChild.setAttribute('stroke-width', '1');
      svg.firstElementChild.setAttribute('d', `M ${i+r} ${i} H ${x-soft} Q ${x} ${i} ${x+t} ${i+t} L ${w-i-t} ${y-t} Q ${w-i} ${y} ${w-i} ${y+soft} V ${h-i-r} Q ${w-i} ${h-i} ${w-i-r} ${h-i} H ${i+r} Q ${i} ${h-i} ${i} ${h-i-r} V ${i+r} Q ${i} ${i} ${i+r} ${i} Z`);
      card.setAttribute('data-ti-outline-ready', '');
    }
    const resize = new ResizeObserver(entries => entries.forEach(({target}) => {
      if (target.isConnected) draw(target); else resize.unobserve(target);
    }));
    function init(root = document) {
      root.querySelectorAll(selector).forEach(card => {
        if (!tracked.has(card)) { tracked.add(card); resize.observe(card); }
        draw(card);
      });
    }
    init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ti-story-configurations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ti-story-switch')) {
 customElements.define('ti-story-switch', class extends HTMLElement {
  connectedCallback() {
   if(this.ready) return;this.ready=true;
   const tabs=[...this.querySelectorAll('[data-ti-tab]')];
   const activate=tab=>{tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1});this.querySelectorAll('[data-ti-panel],[data-ti-image]').forEach(p=>p.hidden=(p.dataset.tiPanel||p.dataset.tiImage)!==tab.dataset.tiTab)};
   tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>activate(tab));tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(tabs[n]);tabs[n].focus()})});
   this.addEventListener('shopify:block:select',e=>{const tab=tabs.find(t=>t.dataset.tiTab===e.detail.blockId);if(tab)activate(tab)});
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ti-story-details"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ti-story-points'))customElements.define('ti-story-points',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;const activate=id=>{this.querySelectorAll('[data-ti-point]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.tiPoint===id)));this.querySelectorAll('[data-ti-detail]').forEach(p=>p.hidden=p.dataset.tiDetail!==id)};this.addEventListener('click',e=>{const b=e.target.closest('[data-ti-point]');if(b)activate(b.dataset.tiPoint)});this.addEventListener('shopify:block:select',e=>activate(e.detail.blockId))}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ti-story-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ti-story-hero')) {
  customElements.define('ti-story-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      if (!dialog) return;
      const video = dialog.querySelector('video');
      this.querySelector('[data-ti-film]').addEventListener('click', () => { dialog.showModal(); video?.play().catch(() => {}); });
      this.querySelector('[data-ti-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => { video?.pause(); this.querySelector('[data-ti-film]').focus(); });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
